// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AqpV","comment":"styles_comment__17GYg"};